import { render, staticRenderFns } from "./rh_recuperar.vue?vue&type=template&id=1c39d3a4&"
import script from "./rh_recuperar.vue?vue&type=script&lang=js&"
export * from "./rh_recuperar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports